import React, { lazy } from 'react';
import { GiftIcon } from 'lucide-react';
import { BONUSES } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export function BonusSection() {
  return <section className="bg-blue-900 py-16 px-4 text-white" data-id="element-26">
      <div className="max-w-7xl mx-auto" data-id="element-27">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-28">
          4 Bonus Gratuiti del valore di 65,96 €
        </h2>
        <p className="text-xl text-center text-blue-200 mb-12" data-id="element-29">
          Inclusi gratuitamente con il tuo acquisto oggi
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-30">
          {BONUSES.map((bonus, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-xl cursor-pointer hover:scale-105 transition-transform duration-300 flex flex-col md:flex-row" onClick={scrollToOffer} data-id="element-31">
              <div className="md:w-2/5 relative" data-id="element-32">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" loading="lazy" data-id="element-33" />
                <div className="absolute top-2 right-2 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-34">
                  GRATIS per oggi
                </div>
              </div>
              <div className="md:w-3/5 p-6" data-id="element-35">
                <div className="flex items-center gap-2 mb-3" data-id="element-36">
                  <GiftIcon className="w-6 h-6 text-orange-500" data-id="element-37" />
                  <span className="text-orange-500 font-bold" data-id="element-38">
                    BONUS {index + 1}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-39">
                  {bonus.title}
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-40">{bonus.description}</p>
                <div className="flex items-center gap-3" data-id="element-41">
                  <span className="text-gray-400 line-through" data-id="element-42">
                    {bonus.value}
                  </span>
                  <span className="text-green-600 font-bold text-lg" data-id="element-43">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-blue-800 bg-opacity-50 border border-blue-700 rounded-lg p-6 text-center mb-8" data-id="element-44">
          <p className="text-xl font-semibold" data-id="element-45">
            In totale riceverai{' '}
            <span className="text-green-400 font-bold" data-id="element-46">9 risorse complete</span>{' '}
            per trasformare le tue lezioni di yoga
          </p>
        </div>

        <div className="text-center" data-id="element-47">
          <button onClick={scrollToOffer} className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-xl py-5 px-10 rounded-full shadow-lg shadow-orange-500/50 transition-all duration-300" data-id="element-48">
            Voglio Tutti i Bonus Gratuiti
          </button>
        </div>
      </div>
    </section>;
}